import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import apiCall from '../../apiCall';
import { thriweMarketPlaceUrl } from '../../../../Containers/Config/index.js';
import { VENDOR_BOOKING_UPDATE, VENDOR_BOOKING_UPDATE_SUCCESS, VENDOR_BOOKING_UPDATE_ERROR } from './../../actionType.js';

function* vendorBookingUpdate({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweMarketPlaceUrl}/v1/admin/vendor-booking-update`,
      method: 'PUT',
      headers: {
        ...payload.headers,
        'Content-Type': 'application/json',
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: VENDOR_BOOKING_UPDATE_SUCCESS,
        payload: response,
      });
    } else if (response?.response?.status === 400 && response?.response?.headers?.authorization) {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: VENDOR_BOOKING_UPDATE_SUCCESS,
        payload: response?.response,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: VENDOR_BOOKING_UPDATE_ERROR,
        payload: response?.data?.message,
      });
    }
  } catch (error) {
    yield put({ type: VENDOR_BOOKING_UPDATE_ERROR, payload: error });
  }
}

export function* watchVendorBookingUpdate() {
  yield takeEvery(VENDOR_BOOKING_UPDATE, vendorBookingUpdate);
}

function* vendorBookingUpdateSaga() {
  yield all([fork(watchVendorBookingUpdate)]);
}

export default vendorBookingUpdateSaga;
